import { transformImage, transformVideo } from '@/helpers/transforms'
import type { VideoBlock as VideoBlockType } from '@/payload-types'
import type { SerializedBlockNode } from '@payloadcms/richtext-lexical'
import type { JSXConverter } from '@payloadcms/richtext-lexical/react'
import { VideoBlock } from '../blocks/VideoBlock'
import ContentBlockWrapper from '../molecules/ContentBlockWrapper'

export const VideoConverter: JSXConverter<SerializedBlockNode<VideoBlockType>> = ({ node }) => {
	const { thumbnail, video } = node.fields

	const thumbnailData = transformImage(thumbnail)
	const videoData = transformVideo(video)

	const thumbnailSizes = '(max-width: 1023px) 100vw, (max-width: 1559px) 83.33vw, 1136px'

	return (
		<ContentBlockWrapper blockTypes={['component']}>
			<div className="col-span-full">
				<div className="relative aspect-video h-auto w-full overflow-hidden rounded-sm">
					{videoData && (
						<VideoBlock
							thumbnail={thumbnailData}
							thumbnailSizes={thumbnailSizes}
							video={videoData}
						/>
					)}
				</div>
			</div>
		</ContentBlockWrapper>
	)
}
